import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Highlight } from '../Highlight';
export function Guarantee() {
  return <section className="border-y border-line bg-surface px-5 py-16 md:py-24" data-id="element-145" data-mp="20meizq13l45g">
      <div className="mx-auto grid max-w-4xl items-center gap-8 rounded-3xl border border-line bg-ink p-8 md:grid-cols-[auto_1fr] md:p-12" data-id="element-146" data-mp="24myc8iijvnmb">
        <div className="mx-auto flex h-32 w-32 flex-col items-center justify-center rounded-full border-4 border-success bg-surface text-center md:h-40 md:w-40" data-id="element-147" data-mp="29f83c1veitq6">
          <ShieldCheckIcon className="h-10 w-10 text-success md:h-12 md:w-12" aria-hidden="true" data-id="element-148" data-mp="2jb1mi43mllgx" />
          <span className="mt-1 text-2xl font-black leading-none text-heading md:text-3xl" data-id="element-149" data-mp="2oc8t3zu18em0">7 días</span>
          <span className="text-[10px] font-bold uppercase tracking-widest text-success" data-id="element-150" data-mp="2sbresxtogtpw">Garantía</span>
        </div>
        <div className="text-center md:text-left" data-id="element-151" data-mp="tyr4salszdpx">
          <h2 className="text-2xl font-black uppercase leading-tight text-heading md:text-4xl" data-id="element-152" data-mp="xyi452peb262">
            Garantía 7 días — sin preguntas
          </h2>
          <p className="mt-4 text-lg text-body" data-id="element-153" data-mp="3smrerk3m8qrm">
            Abres los tomos. Los aplicas en tu vida. Cambias tu relación con el celular.
          </p>
          <p className="mt-2 text-lg text-body" data-id="element-154" data-mp="3iv3sdxlx1zx0">
            Si en 7 días no sientes que tu enfoque mejoró al menos 50% y tu tiempo en pantalla bajó notablemente:
          </p>
          <p className="mt-3 text-xl font-extrabold leading-snug text-heading" data-id="element-155" data-mp="fewmdkg13ql2">
            <Highlight data-id="element-156" data-mp="fctxx4uiy5ig">Devolución del 100%</Highlight> sin preguntas, sin drama.
          </p>
          <p className="mt-4 text-sm font-semibold text-body" data-id="element-157" data-mp="adqufou707cl">
            Tasa de devoluciones: menos del 0.5%.
          </p>
        </div>
      </div>
    </section>;
}